import PropTypes from "prop-types"
import { isNil, isPlainObject } from "lodash"
import OPTooltip from "components/material/tooltip"
import { InfoOutlined } from "@mui/icons-material"

/**
 * Component to render a summary value that may be an object (with tooltip) or a simple value.
 * Handles both new format (object with value and optional tooltip) and old format (simple value).
 */
export default function SummaryValue({ summary, formatter }) {
  // Handle new format: object with value and optional tooltip
  if (isPlainObject(summary) && "value" in summary) {
    const { value, tooltip } = summary
    const formattedValue = isNil(value) ? "-" : formatter(value)

    if (tooltip) {
      return (
        <OPTooltip title={tooltip}>
          <span className="summary-with-tooltip">
            <InfoOutlined fontSize="small" className="summary-tooltip-icon" />
            {formattedValue}
          </span>
        </OPTooltip>
      )
    }

    return <span>{formattedValue}</span>
  }

  // Handle old format: simple value (backwards compatibility)
  const formattedValue = isNil(summary) ? "-" : formatter(summary)
  return <span>{formattedValue}</span>
}

SummaryValue.propTypes = {
  summary: PropTypes.any,
  formatter: PropTypes.func.isRequired,
}
